export default __webpack_public_path__ + "static/media/0xc250e9987a032acac293d838726c511e6e1c029d.74fcff6b.webp";